
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Camera, Shield, Search, Map as MapIcon, Users, Database } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: <Search className="w-8 h-8" />,
      title: "Rastreamento de Veículos",
      description: "Busca avançada por placa completa ou parcial com histórico completo de movimentações.",
      details: ["Último local detectado", "Imagens das câmeras", "Dados do veículo", "Histórico de rotas"]
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Reconhecimento Facial",
      description: "Identificação de pessoas através de upload de fotos com precisão e rapidez.",
      details: ["Busca por foto", "Últimas localizações", "Dados pessoais", "Análise comportamental"]
    },
    {
      icon: <Camera className="w-8 h-8" />,
      title: "Câmeras ao Vivo",
      description: "Acesso em tempo real a câmeras estratégicas em todo território nacional.",
      details: ["Streaming ao vivo", "Controle remoto", "Gravação automática", "Alertas em tempo real"]
    },
    {
      icon: <MapIcon className="w-8 h-8" />,
      title: "Mapa Interativo",
      description: "Visualização geográfica de todas as câmeras e ocorrências em mapa interativo.",
      details: ["Geolocalização precisa", "Status das câmeras", "Filtros avançados", "Rotas otimizadas"]
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Área do Investigador",
      description: "Ferramentas especializadas para investigações profissionais e controle de casos.",
      details: ["Gestão de casos", "Relatórios detalhados", "Alertas automáticos", "Exportação de dados"]
    },
    {
      icon: <Database className="w-8 h-8" />,
      title: "Banco de Dados Nacional",
      description: "Acesso a extenso banco de dados com milhões de registros atualizados diariamente.",
      details: ["Milhões de registros", "Atualizações em tempo real", "Integração nacional", "Backup seguro"]
    }
  ];

  return (
    <section className="py-12 sm:py-20 bg-black/20" id="features">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 sm:mb-16">
          <Badge className="mb-3 sm:mb-4 bg-protec-gold/20 text-protec-gold border-protec-gold/30 text-xs sm:text-sm">
            Funcionalidades Avançadas
          </Badge>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 gradient-text">
            Tecnologia de Ponta
          </h2>
          <p className="text-base sm:text-xl text-gray-300 max-w-3xl mx-auto">
            Sistema completo de monitoramento com recursos avançados para investigação e segurança
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="bg-protec-dark-light border-protec-gold/20 hover:border-protec-gold/40 transition-all duration-300 hover:shadow-gold group">
              <CardHeader className="pb-2 sm:pb-4">
                <div className="text-protec-gold mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300">
                  <div className="w-6 h-6 sm:w-8 sm:h-8">{feature.icon}</div>
                </div>
                <CardTitle className="text-white text-base sm:text-xl mb-1 sm:mb-2">{feature.title}</CardTitle>
                <CardDescription className="text-gray-200 text-sm sm:text-base leading-relaxed">
                  {feature.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-1 sm:space-y-2">
                  {feature.details.map((detail, detailIndex) => (
                    <li key={detailIndex} className="flex items-center text-gray-300 text-xs sm:text-sm">
                      <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-protec-gold rounded-full mr-2 sm:mr-3 flex-shrink-0"></div>
                      {detail}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
